import React, { Component, Fragment } from 'react';
import Slider from 'react-slick';
import { Button, ViewportManager, viewports } from 'luna-react';
import Disclaimer from '../Disclaimer';
import Sparkline from '../Sparkline';
import {
  toLocaleCurrencyString,
  toLocaleNumericString,
  getValueSign,
  getValueVectorSybmol,
} from '../Shared/utils';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CryptoWatch extends Component {
  state = {
    isMobileViewport: true,
    currentSlideIdx: 0,
  }

  updateViewport = ({ windowWidth }) => {
    const isMobileViewport = windowWidth <= viewports.medium;
    this.setState({ isMobileViewport });
  }

  afterSlideChange = (idx) => this.setState(prevState => ({
    currentSlideIdx: idx,
  }))

  getListComponent = () =>
    this.state.isMobileViewport
      ? this.getMobileWrapper()
      : this.getDesktopWrapperComponent();

  getMobileWrapper = () => (props) => (
    <div className="horizontalBox">
      {props.children}
    </div>
  )

  getDesktopWrapperComponent = () => (props) => {
    const { currentSlideIdx } = this.state;
    const settings = {
      autoplay: false,
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      initialSlide: currentSlideIdx,
      afterChange: this.afterSlideChange,
      responsive: [
        { breakpoint: viewports.large, settings: { slidesToShow: 5 } },
      ],
    };

    return  (
      <Fragment>
        <Slider ref={c => this.slider = c} {...settings}>
          {props.children}
        </Slider>
        <Button className="cryptoWatch__sliderNav cryptoWatch__sliderNav--prev"
          iconName="chevron-left"
          iconSize="medium"
          modifiers="link"
          ariaLabel="Prev slide"
          onClick={this.prevSlide}
        />
        <Button className="cryptoWatch__sliderNav cryptoWatch__sliderNav--next"
          iconName="chevron-right"
          iconSize="medium"
          modifiers="link"
          ariaLabel="Next slide"
          onClick={this.nextSlide}
        />
      </Fragment>
    );
  }

  renderCoin = (coin, idx) => {
    const { baseCurrencySymbol } = this.props;
    const {
      name,
      pageLink,
      image,
      price_change_percentage_24h,
      market_cap,
      current_price,
      sparkline_in_7d,
    } = coin;

    const marketCapRawValueInB = parseFloat(market_cap) / 1.0e+9;
    const marketCapInB = toLocaleNumericString({
      value: marketCapRawValueInB,
      fractionDigits: 2,
    });

    const percentChange24hRawValue = parseFloat(price_change_percentage_24h);
    const percentChange24hSign = getValueSign(percentChange24hRawValue);
    const percentChange24h = toLocaleNumericString({
      value: Math.abs(percentChange24hRawValue),
      fractionDigits: 2,
    });


    const currentPrice = parseFloat(current_price);
    const price24h = currentPrice * 100 / (100 + percentChange24hRawValue);
    const change24hRawValue = parseFloat(currentPrice - price24h);
    const change24hVectorSymbol = getValueVectorSybmol(change24hRawValue);
    const change24h = toLocaleCurrencyString({
      currencySymbol: baseCurrencySymbol,
      value: Math.abs(change24hRawValue),
      fractionDigits: 2,
    });

    return (
      <div className="cryptoWatch__tile" key={idx}>
        <div className="cryptoWatch__coin">
          <span className="cryptoWatch__name">{name}</span>
          <strong className="cryptoWatch__percentChange">
            <span data-sign={percentChange24hSign}>{percentChange24h}%</span>
            <img loading="lazy" src={image} alt={`${name} logo`} width="16" height="16" />
          </strong>
          <strong className="cryptoWatch__value">
            {toLocaleCurrencyString({
              currencySymbol: baseCurrencySymbol,
              fractionDigits: 2,
              value: currentPrice,
            })}
          </strong>
          <strong className="cryptoWatch__valueChange">
            <span data-symbol={change24hVectorSymbol}>{change24h}</span>
          </strong>
          <strong data-title="Market Cap" className="cryptoWatch__marketCap">
            {marketCapInB}B
          </strong>
          <Sparkline data={sparkline_in_7d.price} className="cryptoWatch__graph"/>
          <Button href={pageLink} className="cryptoWatch__cta" modifiers="success" label="Buy/Sell" />
        </div>
      </div>
    )
  }

  prevSlide = () => this.slider.slickPrev()

  nextSlide = () => this.slider.slickNext()

  render() {
    const { topCoins = [], lastUpdateDateString } = this.props;

    if (topCoins.length === 0) {
      return '';
    }

    const ListComponent = this.getListComponent();

    return (
      <Fragment>
        <ViewportManager onWindowWidthChange={this.updateViewport} />
        <ListComponent>
          {topCoins.map(this.renderCoin)}
        </ListComponent>
        <Disclaimer lastUpdateDateString={lastUpdateDateString} />
      </Fragment>
    )
  }
}

export default CryptoWatch;



// WEBPACK FOOTER //
// ./src/CryptoWatch/index.js